// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-ywxblcx-index-main_right_content-mTKCX","table":"components-tjcx-ywxblcx-index-table-xpaxB"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/ywxblcx/index.css
// module id = 825
// module chunks = 0